/**
 * @module pagesType
*/

/**
  * @constant
  * @memberof pagesType
  * @name PAGES_TYPE
  * @desc Lista di tutti i tipi di pagina
  * @example PAGES_TYPE.HOME_PAGE
*/

const PAGES_TYPE = {
  HOME_PAGE: 'homepage',
  SRP: 'srp',
  SRP_MAP: 'searchMap',
  HUB_PAGE: 'hubpage',
  PDP: 'pdp',
  AGENCY_PDP: 'agencypdp',
  AGENCY_SRP: 'agencysrp',
  NOT_FOUND: 'notfound',
  CALL_NOW: 'callnow',
  SEARCH_AROUND_YOU: 'cercaintornoate',
};

export default PAGES_TYPE;
